import { InsightsScope } from "hooks/use-insights-scope";
import { IInsightsWorkspaceOption } from "v2/services/insights.service";

/**
 * Recorta a lista de workspaces pelo cliente da tela que abriu o painel.
 *
 * Fora do escopo (a rota `/insights` direta) devolve tudo, como antes.
 */
export function scopeWorkspaces(
  workspaces: IInsightsWorkspaceOption[],
  scope?: InsightsScope | null
): IInsightsWorkspaceOption[] {
  if (!scope) return workspaces;
  return workspaces.filter(
    (workspace) => workspace.buyerOrganizationId === scope.organizationId
  );
}

/**
 * De onde sai a lista de contratos do painel.
 *
 * `true`: percorre os fornecedores do menu (`/v2/organizations/{fornecedor}/workspaces`
 * para cada um), o caminho do RH da empresa cliente. Vale sem escopo (rota
 * `/insights`) e com escopo da própria organização, porque
 * `/v2/organizations/{própria organização}/workspaces` o backend recusa.
 *
 * `false`: uma chamada só, com o id do cliente da tela; é o caminho da
 * corretora, que não tem fornecedor nenhum no menu.
 */
export function listsViaSellers(scope?: InsightsScope | null): boolean {
  return !scope || scope.isOwnOrganization === true;
}
